import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface IEmailPreviewData {
  subject: string;
  html: string;
  body: string;
}

@Component({
  selector: 'el-base-neo-email-preview-popup',
  templateUrl: './email-preview-popup.component.html',
  styleUrls: ['./email-preview-popup.component.scss'],
})
export class EmailPreviewPopupComponent implements OnInit, OnDestroy, AfterViewInit {
  editor = ClassicEditor;
  editorConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote',
      '|',
      'undo',
      'redo',
    ],
  };

  form = new FormGroup({
    subject: new FormControl('', [Validators.required]),
    html: new FormControl('', [Validators.required]),
  });

  previewHtml: SafeHtml = '';
  inlineEditor: any;

  constructor(
    private matDialog: MatDialogRef<EmailPreviewPopupComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: IEmailPreviewData
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.form.patchValue({
        subject: this.data.subject || '',
        html: this.data.body || '',
      });

      if (this.data.html && this.data.body) {
        const placeholder = `<div id="inline-editor-container"></div>`;
        const merged = this.data.html.replace(this.data.body, placeholder);
        this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(merged);
      } else if (this.data.html) {
        this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.html);
      }
    }
  }

  ngAfterViewInit(): void {
    this.initEditor();
  }

  private initEditor(): void {
    setTimeout(() => {
      const el = document.getElementById('inline-editor-container');
      if (el) {
        ClassicEditor.create(el, this.editorConfig)
          .then((editor) => {
            this.inlineEditor = editor;
            editor.setData(this.data.body || '');
            editor.model.document.on('change:data', () => {
              const data = editor.getData();
              this.form.patchValue({ html: data });
            });
          })
          .catch((err) => {
            console.error('Failed to initialize inline CKEditor', err);
          });
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.inlineEditor) {
      this.inlineEditor.destroy()
        .then(() => {
          this.inlineEditor = null;
        })
        .catch((err) => {
          console.error('Failed to destroy inline CKEditor', err);
        });
    }
  }

  onCancel(): void {
    this.matDialog.close(null);
  }

  onSave(): void {
    if (this.form.valid) {
      this.matDialog.close({
        subject: this.form.value.subject,
        html: this.form.value.html,
      });
    }
  }
}
